import { Pipe, PipeTransform } from '@angular/core';
import { TimeZoneService } from 'src/app/_services/time-zone.service';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timeDifference'
})
export class TimeDifferencePipe implements PipeTransform {
  constructor(private timeZoneService: TimeZoneService) {}
  transform(value: any, currentLanguage: string , diffenceInOneUnit:boolean): string {  
    const localTimeFromGivenVlue = this.timeZoneService.convertToLocalTime(value, 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ', 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ', false, currentLanguage);  
    const fromDate = new Date(localTimeFromGivenVlue)

    if(diffenceInOneUnit){
    return this.differenceInOneUnit(fromDate, currentLanguage)
    }

    if(!diffenceInOneUnit){
    return this.differenceInMultipleUnites(fromDate, currentLanguage)
    }

  }


  // difference in one unit 
  differenceInOneUnit(fromDate , language){
    const now = moment().tz(localStorage.getItem('timeZone'))
    const diffInSeconds:any = Math.floor((now.valueOf() - fromDate.getTime()) / 1000);

    if (diffInSeconds < 60) {
      return this.getTimeString(diffInSeconds, language, 'just now', 'الان');
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return this.getTimeString(minutes, language, `${minutes} min ago`, `منذ ${minutes} دقيقة`);
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return this.getTimeString(hours, language, `${hours} hr ago`, `منذ ${hours} ساعة`);
    } else {
      const days = Math.floor(diffInSeconds / 86400);
      return this.getTimeString(days, language, `${days}day ago`, `منذ ${days} يوم`);
    }
  }

  private getTimeString(value: number, language: string, enString: string, arString: string): string {
    if (language === 'ar') {
      // Translate Arabic numbers
      const arabicNumbers = '٠١٢٣٤٥٦٧٨٩';
      const translatedValue = value.toString().split('').map(char => arabicNumbers[parseInt(char, 10)]).join('');

      return arString.replace(/\d+/g, translatedValue);
    } else {
      return enString;
    }
  }

  // difference in multiple unites
  differenceInMultipleUnites(fromDate , currentLanguage){
    const now = moment().tz(localStorage.getItem('timeZone'))
    const timeDifferenceInSeconds = Math.floor((now.valueOf() - fromDate.getTime()) / 1000);

    if (timeDifferenceInSeconds < 1) {
      return currentLanguage === 'ar' ? 'منذ لحظات' : 'just now';
    }

    const timeUnits = [
      { unit: 'day', secondsInUnit: 86400, singularPrefixEn: 'day', pluralPrefixEn: 'days', singularPrefixAr: 'يوم', pluralPrefixAr: 'أيام' },
      { unit: 'hour', secondsInUnit: 3600, singularPrefixEn: 'hour', pluralPrefixEn: 'hours', singularPrefixAr: 'ساعة', pluralPrefixAr: 'ساعات' },
      { unit: 'minute', secondsInUnit: 60, singularPrefixEn: 'minute', pluralPrefixEn: 'minutes', singularPrefixAr: 'دقيقة', pluralPrefixAr: 'دقائق' },
      { unit: 'second', secondsInUnit: 1, singularPrefixEn: 'second', pluralPrefixEn: 'seconds', singularPrefixAr: 'ثانية', pluralPrefixAr: 'ثوانى' },
    ];

    let remainingTime = timeDifferenceInSeconds;
    let result = '';

    for (const unit of timeUnits) {
      if (remainingTime >= unit.secondsInUnit) {
        const numberOfUnits = Math.floor(remainingTime / unit.secondsInUnit);
        const arabicPrefix = this.getArabicPrefix(numberOfUnits, unit.singularPrefixAr, unit.pluralPrefixAr, currentLanguage);

        result += `${this.localizeNumber(numberOfUnits, currentLanguage)} ${currentLanguage === 'ar' ? arabicPrefix : unit.unit}${numberOfUnits !== 1 && currentLanguage === 'en'? 's' : ''} `;
        remainingTime -= numberOfUnits * unit.secondsInUnit;
      }
    }

    return `${currentLanguage === 'ar' ? 'منذ' : ""} ${result.trim()} ${currentLanguage === 'ar' ? '' : "ago"}`;
  }

  localizeNumber(value: any, currentLanguage: string): string {
    if (currentLanguage === 'ar') {
      // Convert the number to Arabic numerals
      const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
      return value.toString().replace(/\d/g, digit => arabicNumerals[parseInt(digit, 10)]);
    } else {
      // If the current language is not 'ar', return the original value
      return value.toString();
    }
  }

  private getArabicPrefix(value: number, singular: string, plural: string, currentLanguage: string): string {
    switch (true) {
      case value === 0 || value === 1 || value === 2 || value > 10:
        return singular;
      case value > 2 && value <= 10:
        return plural;
      default:
        return singular;
    }
  }
}

